import { css, jsx } from '@emotion/react';
import { Alert } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { baseReset, interactiveReset, } from '../../../../utils/style-mixins/reset';
const parsedTime = Date.now();
export const shouldRender = () => {
    const hoursElapsed = (Date.now() - parsedTime) / 1000 / 60 / 60;
    return hoursElapsed > 24;
};
const Styles = labelStyles('RefreshRequired', {
    content: css `
    ${baseReset};
  `,
    button: css `
    ${interactiveReset};
  `,
});
export const Component = function RefreshRequired() {
    return (jsx(Alert, { "aria-live": "polite", variant: "banner", title: "A new version of Zapier is available", status: "info" },
        jsx("p", { "data-zds": true, css: Styles.content },
            jsx("button", { type: "button", css: Styles.button, onClick: () => window.location.reload(), "data-zds": true }, "Refresh now"),
            ' ',
            "to get the latest version")));
};
//# sourceMappingURL=RefreshRequired.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
